/**
 * @generated SignedSource<<687b0f25a486c98b31c56bb74991b4ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type queryBatchSummaryInfoQuery$variables = {
  property_batch_id: number;
};
export type queryBatchSummaryInfoQuery$data = {
  readonly sys_property_batches: ReadonlyArray<{
    readonly property: {
      readonly property_id: number;
      readonly property_name: string | null;
    };
    readonly submission: {
      readonly due_date: string;
      readonly submission_name: string;
    };
    readonly submission_id: number;
  }>;
};
export type queryBatchSummaryInfoQuery = {
  response: queryBatchSummaryInfoQuery$data;
  variables: queryBatchSummaryInfoQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "property_batch_id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "_eq",
                "variableName": "property_batch_id"
              }
            ],
            "kind": "ObjectValue",
            "name": "property_batch_id"
          }
        ],
        "kind": "ObjectValue",
        "name": "where"
      }
    ],
    "concreteType": "sys_property_batches",
    "kind": "LinkedField",
    "name": "sys_property_batches",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "submission_id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "sys_submissions",
        "kind": "LinkedField",
        "name": "submission",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "submission_name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "due_date",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "sys_properties",
        "kind": "LinkedField",
        "name": "property",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "property_name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "property_id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "queryBatchSummaryInfoQuery",
    "selections": (v1/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "queryBatchSummaryInfoQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b62b4e65b6c7296ac72f4cf7ecfd2712",
    "id": null,
    "metadata": {},
    "name": "queryBatchSummaryInfoQuery",
    "operationKind": "query",
    "text": "query queryBatchSummaryInfoQuery(\n  $property_batch_id: Int!\n) {\n  sys_property_batches(where: {property_batch_id: {_eq: $property_batch_id}}) {\n    submission_id\n    submission {\n      submission_name\n      due_date\n    }\n    property {\n      property_name\n      property_id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "047b39481eecc5e66267ee97b046eb4c";

export default node;
